import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const ClientLogos = () => {
  const clients = [
    { 
      name: "Trattoria A Proposito", 
      logo: "/assets/9989ded3-0d73-4c6f-bba2-87361d87f1b7.png",
      industry: "Restaurant",
      darkBg: false
    },
    { 
      name: "Alpacaboerderij Dordrecht", 
      logo: "/assets/d21db470-c4c4-476a-a270-d3e6eb12397d.png",
      industry: "Toerisme",
      darkBg: false
    },
    { 
      name: "BFS7 Accountancy", 
      logo: "/assets/58076ac8-c30a-41e2-b379-7a56a3a04239.png",
      industry: "Accountancy",
      darkBg: false
    },
    { 
      name: "Bosman Schilderwerken", 
      logo: "/assets/25beba82-63cd-4487-b1e1-7dc293cbe499.png",
      industry: "Schilderwerk",
      darkBg: false
    },
    { 
      name: "Budeling Communicatie", 
      logo: "/assets/a60e6f3e-bffb-4e64-a910-555d50c60c89.png",
      industry: "Communicatie",
      darkBg: false
    },
    { 
      name: "Centre Ville Dordrecht", 
      logo: "/assets/e72fe10b-b840-4a52-904b-70e32b002310.png",
      industry: "Retail",
      darkBg: false
    },
    { 
      name: "City Bakery Café", 
      logo: "/assets/bddafe27-9467-46f4-b9cc-a0474b12dd88.png",
      industry: "Horeca",
      darkBg: false
    },
    { 
      name: "Pharmaceutical Solutions B.V.", 
      logo: "/assets/c5f7e13d-92dd-4571-8ccc-be7a544fae00.png",
      industry: "Farmaceutisch",
      darkBg: false
    },
    { 
      name: "Face to Face HairStudio", 
      logo: "/assets/793340a8-7b0d-4a9f-bc0c-2771122375a0.png",
      industry: "Schoonheid",
      darkBg: false
    },
    { 
      name: "Fraas + Faam", 
      logo: "/assets/4cafaedc-00f3-4293-a15b-fd3a8960c7f1.png",
      industry: "Design",
      darkBg: false
    },
    { 
      name: "Gateway Extended", 
      logo: "/assets/02a0ae9d-949d-49fa-b931-abdd25c85272.png",
      industry: "Business Services",
      darkBg: false
    },
    { 
      name: "Groen Rubber Rotterdam", 
      logo: "/assets/340daafc-b57a-4458-8cde-f84b6d86903f.png",
      industry: "Industrie",
      darkBg: false
    },
    { 
      name: "Solarsolutions", 
      logo: "/assets/78bf3100-cc3d-4ecc-a099-b7787d0ae69b.png",
      industry: "Energie",
      darkBg: true
    },
    { 
      name: "Jeanine van IJsseldijk", 
      logo: "/assets/9ceb508b-28a8-4d58-99f2-106b01a1a925.png",
      industry: "Wellness",
      darkBg: false
    },
    { 
      name: "Lankhuijzen Makelaars", 
      logo: "/assets/b567cb02-6e2a-4579-acab-13f08ca58a82.png",
      industry: "Makelaardij",
      darkBg: false
    },
    { 
      name: "Piet Dam Velgenreparatie", 
      logo: "/assets/31b142f1-5cbe-4fa1-820b-94391d39211e.png",
      industry: "Automotive",
      darkBg: false
    },
    { 
      name: "Ottenheijm Afbouw", 
      logo: "/assets/e96e6672-b74c-4143-928b-53cf49b521f5.png",
      industry: "Bouw",
      darkBg: false
    },
    { 
      name: "De Moestenier", 
      logo: "/assets/62c3f342-9408-4e55-b205-4a5e783c781b.png",
      industry: "Retail",
      darkBg: false
    },
    { 
      name: "Triangle Logo", 
      logo: "/assets/05d210d9-267d-4cba-bada-943b175304e2.png",
      industry: "Business",
      darkBg: true
    },
    { 
      name: "Poke Perfect", 
      logo: "/assets/e96a88df-0d95-4e22-95bf-fe33298f6b56.png",
      industry: "Horeca",
      darkBg: false
    },
    { 
      name: "Marck", 
      logo: "/assets/336ff65f-e392-4935-b7c6-8956ede6e514.png",
      industry: "Business Services",
      darkBg: false // Voorbeeld: wit logo op donkere achtergrond
    },
    { 
      name: "OZP Makelaars", 
      logo: "/assets/61519441-a09b-49da-a89a-07cb4424546b.png",
      industry: "Makelaardij",
      darkBg: false
    },
    { 
      name: "PlantConsult", 
      logo: "/assets/70e13039-c4b8-4bf5-9d25-9d8d34065d1c.png",
      industry: "Consultancy",
      darkBg: false
    },
    { 
      name: "PT Elles", 
      logo: "/assets/3643a51b-1a41-4b2c-9737-718e6e266463.png",
      industry: "Fitness",
      darkBg: false
    },
    { 
      name: "Rijschool Nesselande", 
      logo: "/assets/3172b821-441c-4e67-b6e1-99fd0b4017db.png",
      industry: "Onderwijs",
      darkBg: false
    },
    { 
      name: "SLIM Engineering", 
      logo: "/assets/eb71d37b-1db0-4ef7-b2c8-3d7e24617b41.png",
      industry: "Engineering",
      darkBg: false
    },
    { 
      name: "Steuijt Technical Solutions", 
      logo: "/assets/180dd83d-1436-40bf-89ac-5c722ed66831.png",
      industry: "Techniek",
      darkBg: false
    },
    { 
      name: "Tapperij Tijdloos", 
      logo: "/assets/feddb9f1-4751-433b-ad69-5d4d52a1857d.png",
      industry: "Horeca",
      darkBg: false
    },
    { 
      name: "Zagen Zagen", 
      logo: "/assets/bb481f98-f83f-4312-9288-6c310bd65c00.png",
      industry: "Bouw",
      darkBg: false 
    },
    { 
      name: "De Zilte Verleiding", 
      logo: "/assets/d3137cf3-28a1-4521-9877-d7bbfbb168db.png",
      industry: "Horeca",
      darkBg: false
    },
    { 
      name: "Nieuw Logo", 
      logo: "/assets/8df88b0d-01e8-4547-a6a0-757962c0e6ae.png",
      industry: "Business",
      darkBg: true
    },
    { 
      name: "De Hypotheekshop", 
      logo: "/assets/logo-hypotheekshop.webp",
      industry: "Hypotheken",
      darkBg: false
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-secondary mb-4">
            Vertrouwd door 500+ bedrijven
          </h2>
          <p className="text-lg text-muted-foreground">
            Van startups tot grote ondernemingen, zij vertrouwen op ons verzekeringsadvies
          </p>
        </div>

        <Carousel
          plugins={[
            Autoplay({
              delay: 1800,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            }),
          ]}
          opts={{
            align: "center",
            loop: true,
            slidesToScroll: 1,
          }}
          className="w-full relative overflow-hidden"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {clients.map((client, index) => (
              <CarouselItem key={index} className="pl-2 md:pl-4 basis-1/2 md:basis-1/3 lg:basis-1/5">
                <div className="p-2 md:p-4">
                  <div className={`rounded-lg p-4 md:p-6 h-32 md:h-36 flex items-center justify-center hover:shadow-lg transition-all duration-500 group border border-border/50 relative hover:scale-110 hover:z-10 ${
                    client.darkBg ? 'bg-slate-800' : 'bg-card'
                  }`}>
                    <img 
                      src={client.logo} 
                      alt={`${client.name} logo`}
                      className="max-h-20 md:max-h-24 max-w-full object-contain transition-all duration-500 group-hover:scale-110"
                      style={{
                        mixBlendMode: client.darkBg ? 'normal' : 'multiply'
                      }}
                    />
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>

        {/* CSS voor centrum spotlight effect */}
        <style>
          {`
          .embla__slide:nth-child(3n+3) > div > div {
            transform: scale(1.1) !important;
          }
          `}
        </style>

        {/* Trust indicators */}
        <div className="mt-12 text-center">
          <div className="flex flex-wrap justify-center items-center gap-8 text-muted-foreground">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-sm">500+ tevreden klanten</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-sm">15+ jaar ervaring</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-sm">50+ verzekeringsmaatschappijen</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;